import React, { FC } from "react";
import { ButtonBase, InputAdornment, SvgIcon, TextField } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { colors } from "common";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";
import { useIsMobile } from "hooks";
import BazarButton from "components/BazarButton";
import { Paragraph } from "components/Typography";
import { FlexBox } from "components/flex-box";
import { SearchOutlinedIcon } from "components/search-box/SearchBox";

const useStyles = makeStyles(
  // TODO: Recurring style for searchbar. Possibly make exportable constant
  () => ({
    root: {
      backgroundColor: colors.white,
    },
    input: {
      "& label.Mui-focused": {
        color: colors.primary,
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: colors.primary,
      },
      "& .MuiOutlinedInput-root": {
        "&:hover fieldset": {
          borderColor: colors.primary,
        },
        "&.Mui-focused fieldset": {
          borderColor: colors.primary,
        },
      },
    },
  }),
  { index: 999 }
);

type Props = {
  className?: string;
  value?: string;
  onClear?: boolean;
  onChangeKeyword?: (event: any) => void;
  searchKeyword?: () => void;
};

export const PriceListSearchBar: FC<Props> = ({
  value,
  className = "",
  onClear = false,
  searchKeyword,
  onChangeKeyword,
}) => {
  const classes = useStyles();
  const isMobile = useIsMobile();

  const handleClear = () => {
    if (onClear) {
      return onChangeKeyword("");
    }
  };

  const SearchButton = () => {
    return (
      <InputAdornment position="end">
        {onClear && (
          <ButtonBase
            onClick={handleClear}
            sx={{
              position: "absolute",
              right: isMobile ? 90 : 120,
              marginRight: 1.5,
            }}
          >
            <SvgIcon fontSize="small" color="action">
              <ClearIcon />
            </SvgIcon>
          </ButtonBase>
        )}
        {isMobile ?? (
          <BazarButton
            variant="contained"
            color="secondary"
            sx={{
              position: "absolute",
              right: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: isMobile ? 50 : 120,
              height: "100%",
            }}
            onClick={searchKeyword}
          >
            <FlexBox>
              <SearchIcon />
              <Paragraph>Search</Paragraph>
            </FlexBox>
          </BazarButton>
        )}
      </InputAdornment>
    );
  };

  return (
    <div className={className ? className : classes.root}>
      <TextField
        fullWidth
        size="medium"
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            searchKeyword();
            <SearchOutlinedIcon />;
          }
        }}
        value={value}
        onChange={onChangeKeyword}
        className={classes.input}
        InputProps={{
          startAdornment: isMobile && <SearchOutlinedIcon />,
          endAdornment: <SearchButton />,
        }}
        placeholder="Search in Pricelist"
        variant="outlined"
      />
    </div>
  );
};
